import { createSelector } from 'reselect';
import SEARCH_QUERY_FIELDS from '../constants/search-query-fields';
export var getSearchQuery = function (state) { return state.search.searchQuery; };
export var getSearchQueryField = function (state) { return state.search.searchQueryField; };
export var getCategory = createSelector(getSearchQueryField, getSearchQuery, function (field, query) { return (field === SEARCH_QUERY_FIELDS.CATEGORY ? query : ''); });
export var getIsSearching = function (state) { return state.search.isSearching; };
